import requestv2 from "~/utils/http-v2";

const requestDemoApi = {
    gets : async (params) => {
        const url = 'v2/request-demo';
        return await requestv2.get(url, {params});
    },
    detail : async (params) => {
        const url = `v2/request-demo/detail/${params.id}`;
        return await requestv2.get(url, params);
    },
    history : async (id) => {
        const url = `v2/request-demo/history/${id}`;
        return await requestv2.get(url);
    },
    add : async (params) => {
        const url = 'v2/request-demo';
        return await requestv2.post(url, params);
    },
    updateUrl : async (params) => {
        const url = `v2/request-demo/url/${params.id}`;
        return await requestv2.post(url, params);
    },
    delete : async (id) => {
        const url = `v2/request-demo/${id}`;
        return await requestv2.delete(url);
    },
    status : async (params) => {
        const url = `v2/request-demo/status/${params.id}`;
        return await requestv2.post(url, params);
    },
    comment : async (params) => {
        const url = `v2/request-demo/comment/${params.id}`;
        return await requestv2.get(url, {params});
    },
    addComment : async (params) => {
        const url = 'v2/request-demo/comment';
        return await requestv2.post(url, params);
    },
};

export default requestDemoApi;